import { useMemo } from 'react';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { fetchKpiHeatmapCiView, type KpiHeatmapCiFocus } from './kpiDashboardApi';

const STALE_MS = 60_000;
const GC_MS = 10 * 60_000;

export function useKpiHeatmapCiView(
  filterKey: string,
  filterValues: Record<string, string | string[]>,
  focus: KpiHeatmapCiFocus,
  options: { enabled: boolean }
) {
  const timezoneOffset = useMemo(() => new Date().getTimezoneOffset(), []);
  const focusKey = useMemo(() => JSON.stringify(focus), [focus]);

  return useQuery({
    queryKey: ['kpi-heatmap-ci', filterKey, focusKey],
    queryFn: () => fetchKpiHeatmapCiView(filterValues, timezoneOffset, focus),
    enabled: options.enabled,
    staleTime: STALE_MS,
    gcTime: GC_MS,
    placeholderData: keepPreviousData,
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
